import clientConfig from "@template/clientConfig";
import { parse, extract } from "query-string";

const parseUrl = function(str, opts) {
  /**
   * TODO : delete that function that is present in an earlier version of query-string
   * We can't use this function from query-string because query-string is fixed by shared-deps
   */
  return {
    url: str.split("?")[0],
    query: parse(extract(str), opts)
  };
};
const safeEncodeURIComponent = string => {
  return encodeURIComponent(string.toLowerCase())
    .replace(/%20/g, "+")
    .replace(/%7C/g, "|");
};

const addQuerystringSuffix = link => {
  return link.includes("?") ? `${link}&` : `${link}?`;
};

const dedupeNlidQueryString = link => {
  /**
   * Created that function for merging duplicate "nlid" query string present in link from API
   * and generated by our proccessLink function
   *
   * - parseUrl allows to get an array of nlid (duplicated)
   * - merging array of nlid strings
   * - removing duplicate
   * - stringify array joining with |
   * - manually creating URL manipulating query because stringifyURL is encoding the URL
   * (can't decode only the query because we want to keep some encoded query parameters)
   *
   */
  const parsedURL = parseUrl(link);

  parsedURL.query["nlid"] = Array.from(
    new Set(parsedURL.query["nlid"].join("|").split("|"))
  ).join("|");

  return Object.keys(parsedURL.query).reduce((acc, queryKey, index) => {
    return (
      acc +
      `${queryKey}=` +
      safeEncodeURIComponent(parsedURL.query[queryKey]) +
      (index < Object.keys(parsedURL.query).length - 1 ? "&" : "")
    );
  }, `${parsedURL.url}?`);
};

const proccessLink = ({
  link,
  gender,
  section,
  container,
  label,
  marketplaceMVTBucket
}) => {
  let finalLink;
  let marketplaceAnalyticParams = "";

  const parsedURL = parseUrl(link);
  const originalLinkContainsNlid = "nlid" in parsedURL.query;
  const labelParam = label ? `|${safeEncodeURIComponent(label)}` : "";

  // /* istanbul ignore next */
  if (section.includes("Marketplace") && !clientConfig.isServer()) {
    marketplaceAnalyticParams = addAnalyticParamsToMarketplaceLink(
      gender,
      marketplaceMVTBucket
    );
  }

  if (container) {
    finalLink = `${addQuerystringSuffix(link)}nlid=${safeEncodeURIComponent(
      gender
    )}|${safeEncodeURIComponent(section)}|${safeEncodeURIComponent(
      container
    )}${labelParam}${marketplaceAnalyticParams}`;
  } else {
    finalLink = `${addQuerystringSuffix(link)}nlid=${safeEncodeURIComponent(
      gender
    )}|${safeEncodeURIComponent(
      section
    )}${labelParam}${marketplaceAnalyticParams}`;
  }

  if (originalLinkContainsNlid) {
    return dedupeNlidQueryString(finalLink);
  }
  return finalLink;
};

const addAnalyticParamsToMarketplaceLink = (gender, marketplaceMVTBucket) => {
  let marketplaceAnalyticParams = "";
  if (marketplaceMVTBucket?.mobile === "v2") {
    marketplaceAnalyticParams = `${marketplaceAnalyticParams}|emf137_v2_${gender}`;
  } else if (marketplaceMVTBucket?.mobile === "v1") {
    marketplaceAnalyticParams = `${marketplaceAnalyticParams}|emf137_v1_${gender}`;
  }
  /* istanbul ignore else */
  if (marketplaceMVTBucket?.desktop === "v2") {
    marketplaceAnalyticParams = `${marketplaceAnalyticParams}|emf95_v2_${gender}`;
  } else if (marketplaceMVTBucket?.desktop === "v1") {
    marketplaceAnalyticParams = `${marketplaceAnalyticParams}|emf95_v1_${gender}`;
  }

  return marketplaceAnalyticParams;
};

export const addAnalyticsDataToLink = ({
  link,
  gender,
  labelPath,
  label,
  marketplaceMVTBucket
}) => {
  if (!link) {
    return null;
  }

  if (!gender) {
    return link;
  }

  if (labelPath.length === 6) {
    const [, , , section, container] = labelPath;
    if (section && container) {
      return proccessLink({
        link,
        section,
        container,
        label,
        gender,
        marketplaceMVTBucket
      });
    }
  }

  if (labelPath.length === 4) {
    const [, , section] = labelPath;

    if (section) {
      return proccessLink({
        link,
        section,
        gender,
        label,
        marketplaceMVTBucket
      });
    }
  }

  return link;
};
